export default "__VITE_ASSET__755268cd__"